/* src/modules/course_approvals/api.js */

import gql from 'graphql-tag';

const COURSE_APPROVAL_FRAGMENT = gql`
  fragment CourseApprovalFragment on CourseApproval {
    course {
      _id
      university {
        _id
        name
      }
      subject
      number
      title
    }
    status
    requestedAt {
      timestamp
    }
  }
`;

const COURSE_APPROVAL_TUTOR_FRAGMENT = gql`
  fragment CourseApprovalTutorFragment on Tutor {
    _id
    user {
      _id
      first
      last
    }
    universities {
      _id
      name
    }
    courses {
      ...CourseApprovalFragment
    }
    organization {
      name
    }
  }
  ${COURSE_APPROVAL_FRAGMENT}
`;

export const FETCH_COURSE_APPROVAL_TUTORS_QUERY = gql`
  query fetchCourseApprovalTutors($tutorSearchInput: TutorSearchInput!) {
    tutors(input: $tutorSearchInput) {
      ...CourseApprovalTutorFragment
    }
  }
  ${COURSE_APPROVAL_TUTOR_FRAGMENT}
`;

export const UPDATE_COURSE_APPROVAL_MUTATION = gql`
  mutation updateCourseApproval($tutor: ID!, $course: ID!, $status: CourseApprovalStatus!) {
    modifyCourseApprovalStatus(_tutor: $tutor, _course: $course, status: $status) {
      ...CourseApprovalFragment
    }
  }
  ${COURSE_APPROVAL_FRAGMENT}
`;

export const ADD_COURSES_TO_TUTOR_MUTATION = gql`
  mutation addCoursesToTutor($tutor: ID!, $university: ID! $courses: [ID]!) {
    addCoursesToTutor(_tutor: $tutor, _university: $university, courses: $courses) {
      ...CourseApprovalTutorFragment
    }
  }
  ${COURSE_APPROVAL_TUTOR_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/course_approvals/api.js